import { Permission } from "~/hooks/permissions";

import PatientList from "./PatientList";
import PatientImport from "./PatientImport";
import CensusLocationIndexView from "../census-location";
import TabsPage from "~/components/layout/TabsPage";
import { useParams } from "react-router-dom";
import PatientDetailView from "./patientDetails";

const PatientManagement = () => {
  const { tab } = useParams<{ tab: string }>();

  if (tab && parseInt(tab) > 0) {
    return <PatientDetailView patientId={parseInt(tab)} />
  }

  return <TabsPage basePath="patients" tabs={{
    'list': {
      label: 'List',
      permission: Permission.useWebApp,
      component: () => <PatientList />
    },
    'map': {
      label: 'Map',
      permission: Permission.useWebApp,
      component: () => <CensusLocationIndexView />
    },
    'import': {
      label: 'Import',
      permission: Permission.importPatients,
      component: () => <PatientImport />
    },
  }}/>
}

export default PatientManagement;
